import { __ } from '@wordpress/i18n';
import { InnerBlocks,BlockControls } from '@wordpress/block-editor';
import PanelSettings from './advance/inspector-control';
import AdvanceSettings from './advance';
import {VariationPicker} from './variation-picker';
import { useEffect } from 'react';
import {CopyPasteStyles} from '@vayu-blocks';

export function Edit({attributes, setAttributes, clientId, isSelected } ) {
	
	useEffect(() => {
		setAttributes({ uniqueId: `vb-${clientId.substring(0, 8)}` });
	}, [clientId]);

	const advance_timeline_template = [
		['vayu-blocks/timeline-child', {
            className: `vayu_blocks__advance-timeline-timeline-child`,
        }],
		['vayu-blocks/timeline-child', {
            className: `vayu_blocks__advance-timeline-timeline-child`,
        }],
		['vayu-blocks/timeline-child', {
            className: `vayu_blocks__advance-timeline-timeline-child`,
        }],
    ];

	return (
		<>
			<BlockControls>
                <CopyPasteStyles attributes={attributes} setAttributes={setAttributes} blockName={'vayu-blocks/advance-timeline'}/>
            </BlockControls>

			<PanelSettings attributes={attributes} setAttributes={setAttributes} isSelected={isSelected} clientId={clientId}/>
			
			<AdvanceSettings attributes={attributes} setAttributes={setAttributes} clientId={clientId}>
				{attributes.timelinelayout ? (
					<>
						<div  className={`vayu_blocks_advance-timeline_block_main ${(attributes.timelinelayout==='layout-7' ||attributes.timelinelayout==='layout-8'|| attributes.timelinelayout==='layout-9' || attributes.timelinelayout==='layout-10' || attributes.timelinelayout==='layout-11' || attributes.timelinelayout==='layout-12' ) ? 'vayu-blocks-laytout-7-advance-timeline' : 'vayu-blocks-laytout-1-advance-timeline'}`}>			

							<InnerBlocks
								template={advance_timeline_template}
								allowedBlocks={['vayu-blocks/timeline-child']}
							/>

						</div>

					</>
				):(
					<VariationPicker
						inTimeLineLayout={(value)=>setAttributes({timelinelayout:value})}
					/>
				)}

			</AdvanceSettings>
			
		</>
	);
}

export default Edit; 